import capitalize from 'lodash/capitalize';
const t = str => str;
export const getMailboxLabel = (mailboxType, __ = t) => {
  if (mailboxType === 'standard') {
    return __('3GB Standard mailbox');
  }
  return __('50GB Premium mailbox');
};
export const getMailboxDescription = (mailboxType, __ = t) => {
  if (mailboxType === 'standard') {
    return __('3 GB of storage');
  }
  return __('50 GB of storage');
};
export const getCertificateLabel = (certificateOptions, __ = t) => {
  if (!certificateOptions) {
    return __('Information not available');
  }
  const parts = [];
  parts.push(__(certificateOptions.type));
  switch (certificateOptions.protect) {
    case 'single':
      parts.push(__('Single address'));
      break;
    case 'multi':
      parts.push(__('Multi address'));
      break;
    case 'wildcard':
      parts.push(__('Full domain'));
      break;
    default:
      break;
  }
  return parts.map(capitalize).join(' - ');
};